var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-steps',{attrs:{"current":_vm.active,"direction":_vm.direction,"initial":_vm.initialActive,"size":_vm.size,"status":_vm.status,"title":_vm.title},scopedSlots:_vm._u([(_vm.$scopedSlots.progressDot)?{key:"progressDot",fn:function(slotData){return [_vm._t("progressDot",null,null,slotData)]}}:null],null,true)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }